import { IntlShape } from 'react-intl';
import { ProjectsData } from 'utils/helpers/renameKeys';
import { BusinessTrip } from './types';

export const projectsFilter = (
  client: string,
  projectsData: ProjectsData[],
) => {
  return projectsData.filter((data) => data.client.clientName === client);
};

const MAX_COUNT_OF_NUMBERS = 4;

export const getHelperText = (intl: IntlShape) => {
  return {
    maxValue: intl.formatMessage({
      id: 'VALIDATION.MAX_VALUE',
    }),
    maxLength: intl.formatMessage({
      id: 'VALIDATION.MAX_LENGTH',
    }),
  };
};

const maxValue = (intl: IntlShape, days: number) => ({
  value: days,
  message: `${getHelperText(intl).maxValue} ${days}`,
});

const maxLength = (intl: IntlShape) => ({
  value: MAX_COUNT_OF_NUMBERS,
  message: getHelperText(intl).maxLength,
});

export const validateBusinessTrips = (intl: IntlShape, days: number) => {
  return {
    maxValue: {
      max: maxValue(intl, days),
    },

    maxLength: {
      maxLength: maxLength(intl),
    },
  };
};

export const preparePreviousData = (
  previousData: BusinessTrip,
  intl: IntlShape,
) => {
  return {
    id: previousData.id,
    tripReason: previousData.tripReason,
    country: { ...previousData.countryDiet },
    city: previousData.city,
    client: {
      clientName: previousData.client.clientName,
      name: previousData.client.clientName,
      status: previousData.client.status,
      value: 0,
      description: previousData.client.description,
    },
    project: previousData.project
      ? {
          ...previousData.project,
          name: previousData.project?.projectName,
          value: 0,
        }
      : undefined,
    startTime: new Date(previousData.startTime),
    endTime: new Date(previousData.endTime),
    transportation: {
      value: previousData.transportation[0].expenseType,
      name: intl.formatMessage({
        id: `BUSINESS_TRIP.${previousData.transportation[0].expenseType}`,
      }),
    },
    travelFrom: previousData.travelFrom,
    travelTo: previousData.travelTo,
    travelReservationBy: previousData.travelReservationBy
      ? {
          value: `${previousData.travelReservationBy}`,
          name: intl.formatMessage({
            id: `BUSINESS_TRIP.${previousData.travelReservationBy}`,
          }),
        }
      : undefined,
    travelReservationLink: previousData.travelReservationLink || '',
    reservationInformation: previousData.reservationInformation || '',
    numberOfNights: previousData.numberOfNights,
    placeToStay: previousData.placeToStay,
    estimateCostsOfStay: previousData.estimatedCostsOfStay || undefined,
    currency: { name: previousData.currency, value: 0 } || undefined,
    neededAdvance: previousData.advance,
    accommodationReservationBy: {
      value: `${previousData.accommodationReservationBy}`,
      name: intl.formatMessage({
        id: `BUSINESS_TRIP.${previousData.accommodationReservationBy}`,
      }),
    },
    accommodationReservationLink:
      previousData.accommodationReservationLink || '',
    accommodationInformation: previousData.accommodationInformation || '',
    insuranceProvidedBy: {
      value: `${previousData.insuranceProvidedBy}`,
      name: intl.formatMessage({
        id: `BUSINESS_TRIP.${previousData.insuranceProvidedBy}`,
      }),
    },
    advanceDescription: previousData.advanceDescription,
    otherInformation: previousData.otherInformation || '',
    clientAcceptance: false,
    accountId: previousData.account?.id,
    // Completed with the order's period once the eligible orders load.
    order: previousData.orderNumber
      ? { value: previousData.orderNumber, name: previousData.orderNumber }
      : null,
  };
};
